import { computed, ComputedRef } from "vue";
import { Articulo } from "../../../interface/rp-response/articles.response";

/**
 * Función computada de Vue para obtener un array ordenado de artículos. Primero los artículos con stock disponible, luego los artículos sin stock.
 * @param response Array de artículos en crudo de la api de artículos o "false" caso contrario.
 * @returns Valor computado de Vue con un array ordenado de artículos.
 */

// Funcion computada para devolver primero los articulos con stock y luego los que no tienen stock.
export const sortResponse = (response: Articulo[] | boolean): ComputedRef<Articulo[]> => {
    return computed(() => {
        if (!response || typeof response === 'boolean') return [];

        // Separar productos en tres categorías: combos, con stock y sin stock
        const combos: Articulo[] = response?.filter(item => item.clasificacion === 'C') || [];
        const productosEnStock: Articulo[] = response?.filter(
            item => item.clasificacion !== 'C' && (item.canti_stock - item.canti_reser) > 0
        ) || [];
        const productosSinStock: Articulo[] = response?.filter(
            item => item.clasificacion !== 'C' && (item.canti_stock - item.canti_reser) <= 0
        ) || [];

        // Devolver en orden: combos primero, luego con stock, finalmente sin stock
        return [...combos, ...productosEnStock, ...productosSinStock];
    });
}